import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

export class CampanhaFilterInitialization {
    private main: boolean;
    private area: boolean;
    initialization = new Subject<boolean>();
    initializing = new BehaviorSubject<boolean>(true);
    initialized = new BehaviorSubject<boolean>(false);

    constructor() {
        this.main = false;
        this.area = false;
        this.init();
    }

    private init() {
        this.initialization.subscribe(
            isInitialized => {
                if (isInitialized) {
                    this.initializing.next(false);
                    this.initializing.complete();

                    this.initialized.next(true);
                    this.initialized.complete();
                }
            }
        );
    }

    isInitialized(): boolean {
        return this.main && this.area;
    }

    initializeMain() {
        this.main = true;
        this.initialization.next(this.isInitialized());
    }

    initializeArea() {
        this.area = true;
        this.initialization.next(this.isInitialized());
    }
}
